<template>
  <video autoplay muted controls class="home-video" :src="video"></video>
</template>
<script>
import { defineComponent } from 'vue'
import video from '@/assets/video/SUPERWYKONAWCA.mp4'

export default defineComponent({
  name: 'HomeVideo',
  data () {
    return {
      video
    }
  }
})
</script>

<style lang="scss" scoped>
video{
  max-width: 100%;
  width: 100%;
  height: 400px;
  background-color: #000;
  margin-bottom: 41px;
}
</style>